function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#FFADC2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.65296 6.52812C6.08835 6.17605 6.61261 6 7.22564 6H9.49702C9.77316 6 9.99702 6.22386 9.99702 6.5V13.5C9.99702 13.7761 9.77316 14 9.49702 14H7.22564C6.61261 14 6.08835 13.824 5.65296 13.4717C5.21768 13.1198 5 12.6957 5 12.1999V7.79995C5 7.30412 5.21768 6.8802 5.65296 6.52812Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.9358 9.85196L13.098 8.06249C13.0552 8.02088 13.0045 8 12.946 8C12.8874 8 12.8367 8.02088 12.7939 8.06249C12.7511 8.10416 12.7297 8.15356 12.7297 8.21054V9.15789H11.2162C11.1576 9.15789 11.107 9.17876 11.0642 9.22038C11.0214 9.26205 11 9.31141 11 9.36843V10.6316C11 10.6886 11.0214 10.7379 11.0642 10.7796C11.107 10.8212 11.1577 10.8421 11.2162 10.8421H12.7297V11.7894C12.7297 11.8464 12.7511 11.8958 12.7939 11.9375C12.8367 11.9791 12.8874 12 12.946 12C13.0045 12 13.0552 11.9791 13.098 11.9375L14.9358 10.1481C14.9786 10.1064 15 10.0571 15 10C15 9.94304 14.9786 9.89364 14.9358 9.85196Z",
  fill: "white"
});

var SvgExitPageMobileNav = function SvgExitPageMobileNav(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExitPageMobileNav, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ExitPageMobileNav.0cbbb5f6.svg";
export { ForwardRef as ReactComponent };